import { Modal as ModalBase } from "@ubnt/store.core/lib/components/Modal";
import styled from "styled-components";
import { VideoPlayer as VideoPlayerBase } from "@ubnt/store.core/lib/components/VideoPlayerNew";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const CONTENT_CLASSNAME = "modal-content";

export const Modal = styled(ModalBase)`
  border-radius: 8px;

  .${CONTENT_CLASSNAME} {
    padding: 0;
    margin: 0;
  }

 @media ${BREAKPOINTS.TABLET_AND_DOWN} {
  max-width: 96%;
 }
`;

export const VideoPlayer = styled(VideoPlayerBase)`
  background-color: transparent;
  border-radius: 8px;

  // Fixes the issue with the video having white border on the bottom
  // Maybe something to do with the video scaling
  overflow: hidden;
  video {
    margin: -4px;
    width: calc(100% + 8px);
  }
`;
